import { disableClickhouseDependencies, enableFlagListLastEvaluatedSort } from '@gonfalon/dogfood-flags/dogfood-flags';

import { type SortOrdering } from './types';

export function isLastEvaluatedSort(sort: SortOrdering | undefined) {
  return sort === 'lastEvaluated' || sort === '-lastEvaluated';
}

export function isLastEvaluatedSortAvailable() {
  return enableFlagListLastEvaluatedSort() && !disableClickhouseDependencies();
}

export function withoutUnavailableSort(sort: SortOrdering | undefined) {
  return isLastEvaluatedSort(sort) && !isLastEvaluatedSortAvailable() ? undefined : sort;
}

export function orderEnvironmentKeysForSort(
  environmentKeys: string[],
  selectedEnvironmentKey: string,
  sort: SortOrdering | undefined,
) {
  if (!isLastEvaluatedSort(sort) || !environmentKeys.includes(selectedEnvironmentKey)) {
    return environmentKeys;
  }
  return [selectedEnvironmentKey, ...environmentKeys.filter((key) => key !== selectedEnvironmentKey)];
}
